// Central data-testid constants
export const IDS = {
  nav: {
    root: "site-nav",
    logo: "nav-logo",
    home: "nav-home",
    services: "nav-services",
    cities: "nav-cities",
    about: "nav-about",
    contact: "nav-contact",
    cta: "nav-cta-quote",
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
  },
  hero: {
    root: "hero",
    heading: "hero-heading",
    cta: "hero-cta-quote",
    scroll: "hero-scroll-indicator",
  },
  services: {
    grid: "services-grid",
    card: (slug) => `service-card-${slug}`,
    detail: (slug) => `service-detail-${slug}`,
    indexRoot: "services-index",
  },
  cities: {
    grid: "cities-grid",
    row: (slug) => `city-row-${slug}`,
    detail: (slug) => `city-detail-${slug}`,
    indexRoot: "cities-index",
  },
  quote: {
    form: "quote-form",
    name: "quote-name",
    email: "quote-email",
    phone: "quote-phone",
    service: "quote-service",
    city: "quote-city",
    message: "quote-message",
    submit: "quote-submit-btn",
    success: "quote-success",
    error: "quote-error",
  },
  contact: {
    form: "contact-form",
    name: "contact-name",
    email: "contact-email",
    message: "contact-message",
    submit: "contact-submit-btn",
  },
  footer: {
    root: "site-footer",
    servicesList: "footer-services",
    citiesList: "footer-cities",
  },
};
